class CollectionDescriptionToggle extends HTMLElement {
  constructor() {
    super();
    
    this.preview = this.querySelector('[data-preview]');
    this.content = this.querySelector('[data-content]');
    this.buttons = this.querySelectorAll('[data-button]');
    
    this.isExpanded = false;
    
    this.handleClick = this.handleClick.bind(this);
  }
  
  connectedCallback() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleClick);
    });
  }
  
  disconnectedCallback() {
    this.buttons.forEach(button => {
      button.removeEventListener('click', this.handleClick);
    });
  }
  
  handleClick() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.classList.add('is-expanded');
    } else {
      this.classList.remove('is-expanded');
    }
  }
}

if (!customElements.get('collection-description-toggle')) {
  customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}
